import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Header from "../../../components/Header/Header";
import IndentDetails from "../IndentPage/ItemsPage/IndentDetails";
import ItemsTable from "./IRItemsTable";
import { useSelector } from "react-redux";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const IRStoreHeadPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { row } = location.state || {};

  const [items, setItems] = useState([]);
  const [error, setError] = useState(null);
  const currentUserId = useSelector((state) => state.auth.id);
  const [indentStatus, setIndentStatus] = useState({
    l1a: row?.L1A || 0,
    l1: row?.L1 || 0,
    l2: row?.L2 || 0,
    po: row?.PO || 0,
    ph: row?.PH || 0,
    ir: row?.IR || 0,
    sh: row?.SH || 0, // Explicitly set to 0 for store head approval
    isClosed: false,
  });

  useEffect(() => {
    const fetchStoreHeadItems = async () => {
      if (row && row.IndentID) {
        try {
          const response = await axios.get(
            `${API_BASE_URL}/irpage/indents/difference/${row.IndentID}`
          );

          const differenceItems = response.data.items
            .filter((item) => item.Difference !== 0)
            .map((item) => ({
              itemID: item.ItemID,
              itemName: item.ItemName,
              quantity: item.Quantity,
              quantityReceived: item.QuantityReceived || 0,
              difference: item.Difference,
              stock: item.Stock || 0,
              categoryID: item.CategoryID,
              remarks: item.Description,
              promisedDate: item.PromisedDate,
              unitname: item.UnitName,
            }));

          setItems(differenceItems);
        } catch (error) {
          setError(
            error.response?.data?.message || "Failed to load items for Store Head approval"
          );
        }
      }
    };

    fetchStoreHeadItems();
  }, [row]);

  const handleIndentStatusChange = (newStatus) => {
    setIndentStatus((prevStatus) => ({
      ...prevStatus,
      ...newStatus,
    }));

    if (newStatus.isClosed) {
      navigate("/IRpage", {
        state: {
          message: "Indent Closed Successfully",
        },
      });
    }
  };

  return (
    <div>
      <Header />
      <div className="container mx-auto p-6">
        {!row ? (
          <div className="text-center text-red-500">
            No indent data found. Please select an indent first.
          </div>
        ) : (
          <>
            <div className="mt-6 mb-2 text-center">
              <h3 className="text-xl font-semibold">Store Head Approval</h3>
            </div>
            <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-md mb-4">
              <p className="text-yellow-700 font-medium">
                Send for Store Head Approval: Quantity and Quantity Received Mismatch
              </p>
            </div>

            {error && (
              <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                {error}
              </div>
            )}

            <IndentDetails row={row} userId={currentUserId} />
            <ItemsTable
              indentID={row.IndentID}
              items={items}
              onIndentStatusChange={handleIndentStatusChange}
              isClosed={indentStatus.isClosed}
              userId={currentUserId}
              indentStatus={{
                l1a: indentStatus.l1a,
                l1: indentStatus.l1,
                l2: indentStatus.l2,
                po: indentStatus.po,
                ph: indentStatus.ph,
                ir: indentStatus.ir,
                sh: 0, // Explicitly set to 0 for store head approval
              }}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default IRStoreHeadPage;
